import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  GET_REQUEST,
  DELETE_REQUEST,
  POST_REQUEST,
} from "../../HooksApi/useApi";
import UseGetData from "../../HookAxios/getdata";
import deleteData from "../../HookAxios/delete";
import { USeInsertData } from "../../HookAxios/postData";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
const HookVedCourse = () => {
  const theme = useTheme();
  const navigate = useNavigate()
  const med = useMediaQuery(theme.breakpoints.down("md"));
  const { id, idVed } = useParams();
  const AboutCourse = useSelector((state) => state.Courses.AboutCourse);
  const SectionsBy = useSelector(
    (state) => state.Courses.SectionsByCourse.data
  );
  const SessionsBy = useSelector(
    (state) => state.Courses.SessionsByCourse.data
  );
  const token = useSelector((state) => state.Auth.userInfo.token);
  const idUser = useSelector((state) => state.Auth.userInfo.data.id);
  const ApiVed = useRef();
  const resultTextRef = useRef(null);

  const [expanded, setExpanded] = useState("");
  const [expandedComp, setExpandedComp] = useState("");
  const [expandedCom, setExpandedCom] = useState("");
  const [ShowVedio, setShowVedio] = useState(true);

  const {
    mutate: DeleteComment,
    isLoading: LoadDelete,
    data: dataDelete,
  } = DELETE_REQUEST({
    request: (id) =>
      deleteData(
        "delete_comment",
        { id: id },
        { Authorization: `Bearer ${token} ` }
      ),
    handelOnSettledData: DeletSucses,
    DeletEror,
  });
  function DeletSucses(data) {
    refetchPending();
  }
  function DeletEror(data) {
    refetchPending();
  }

  const { isLoading: loadingRefrances, data: getRefrences } = GET_REQUEST({
    queryKey: `get_refrences${idVed}`,
    request: () =>
      UseGetData(
        "get_refrences",
        { id: idVed },
        { Authorization: `Bearer ${token} ` }
      ),
    enabled: true,
  });
  const {
    isLoading,
    data: dataProg,
    refetch,
  } = GET_REQUEST({
    queryKey: `get_course_progress${id}`,
    request: () =>
      UseGetData(
        "get_course_progress",
        { course_id: id },
        { Authorization: `Bearer ${token} ` }
      ),
    enabled: false,
  });
  const {
    isLoading: LoadPending,
    data: dataPending,
    refetch: refetchPending,
  } = GET_REQUEST({
    queryKey: `Qustions${idVed}`,
    request: () =>
      UseGetData(
        "get_session_comments",
        { id: idVed },
        { Authorization: `Bearer ${token} ` }
      ),
    enabled: true,
  });
  const {
    isLoading: LoadPart,
    data: dataVedio,
    isFetching: FetchingPart,
    isError: isErrorPart,
    error: errorPart,
    refetch: refetcPart,
  } = GET_REQUEST({
    queryKey: `vedGet${idVed}`,
    request: () =>
      UseGetData(
        "get_session_by_id",
        { id: idVed },
        { Authorization: `Bearer ${token} ` }
      ),
    enabled: true,
  });
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleChangeComp = (panel) => (event, newExpanded) => {
    setExpandedComp(newExpanded ? panel : false);
  };
  const handleChangeCom = (panel) => (event, newExpanded) => {
    setExpandedCom(newExpanded ? panel : false);
  };
  const {
    isLoading: LoadParts,
    data: dataParts,
    refetch: refetchSessions,
  } = GET_REQUEST({
    queryKey: `CoursePart${expanded}`,
    request: () =>
      UseGetData(
        "get_sessions_by_section_id",
        { id: expanded },
        { Authorization: `Bearer ${token}` }
      ),
    enabled: false,
  });
  const { mutate: setWatch, data } = POST_REQUEST({
    request: (data) =>
      USeInsertData("/set_session_progress", data, {
        Authorization: `Bearer ${token}`,
      }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {}
  function handelOnSettledData(data) {}
  useEffect(() => {
    if (expanded !== "" && expanded) refetchSessions();
  }, [expanded]);
  useEffect(() => {
    if (token) refetch();
  }, [token]);

  useEffect(() => {
    if(errorPart) console.log("the erorrrrrr is ",errorPart)
    if(isErrorPart) console.log("the isErrorPart is ",isErrorPart)
    if (
      dataVedio?.data?.data?.is_public ||
      (!dataVedio?.data?.data?.is_public &&
        dataVedio?.data?.data?.is_subscribtion)
    ) {
      const code = dataVedio?.data?.data?.embeded_code;
      const div = document.createElement("divs");
      div.innerHTML = code.trim();
      let iframe = div.firstChild;
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("height", "100%");
      if (ApiVed.current && !ApiVed.current.children[0]) {
        ApiVed.current.appendChild(iframe);
      }
    }
  }, [dataVedio, ApiVed, LoadPart, ShowVedio,errorPart,isErrorPart]);

  useEffect(() => {
    setShowVedio(true);
  }, [idVed]);

  return {
    id,
    AboutCourse,
    SectionsBy,
    SessionsBy,
    idUser,
    expanded,
    LoadPart,
    dataVedio,
    handleChange,
    ApiVed,
    idVed,
    dataParts,
    LoadParts,
    handleChangeComp,
    expandedComp,
    handleChangeCom,
    expandedCom,
    LoadPending,
    dataPending,
    DeleteComment,
    ShowVedio,
    setShowVedio,
    med,
    resultTextRef,
    setWatch,
    refetchPending,
    dataProg,
    isLoading,
    loadingRefrances,
    getRefrences,
  };
};

export default HookVedCourse;
